export default "__VITE_PUBLIC_ASSET__5221d07b__"